import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const Props = {
    image: PropTypes.string,
    alt: PropTypes.string
};

const SpeakerImage = ({ image, alt }) => {
    const imgRef = React.createRef();
    const emptyImageSource = '/images/agenda/SpeakerIcon.png';
    return (
        <Fragment>
            {
                image &&
           <img className="speaker-image-stub"
               src={image} alt={alt}
               ref={imgRef}
               onError={() => {
                   imgRef.current.src = emptyImageSource;
                   imgRef.current.className = 'speaker-image-stub error-load';
               }}/>
            }
            {
                !image &&
            <div className="speaker-image-stub bz-flex-row">
                <img className="speaker-image" src={emptyImageSource} alt={alt} />
            </div>
            }
        </Fragment>
    );
};

SpeakerImage.propType = Props;

export default SpeakerImage;
